import { BaseFetch } from "../main-model"
export default class LearningSubGroupModel extends BaseFetch {
    getLearningSubGroupBy = (data) =>
        this.authFetch({
            url: "learning-sub-group/getLearningSubGroupBy",
            method: "POST",
            body: JSON.stringify(data),
        })
    getLearningSubGroupById = (data) =>
        this.authFetch({
            url: "learning-sub-group/getLearningSubGroupById",
            method: "POST",
            body: JSON.stringify(data),
        })
    updateLearningSubGroupById = (data) =>
        this.authFetch({
            url: "learning-sub-group/updateLearningSubGroupById",
            method: "POST",
            body: JSON.stringify(data),
        })
    insertLearningSubGroup = (data) =>
        this.authFetch({
            url: "learning-sub-group/insertLearningSubGroup",
            method: "POST",
            body: JSON.stringify(data),
        })
    deleteLearningSubGroupById = (data) =>
        this.authFetch({
            url: "learning-sub-group/deleteLearningSubGroupById",
            method: "POST",
            body: JSON.stringify(data),
        })
}
